"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useClickOutside = function (closeHandler) {
    var ref = react_1.default.useRef(null);
    var handleClickOutside = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            closeHandler();
        }
    };
    react_1.default.useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return { ref: ref };
};
exports.default = useClickOutside;
